import { WorkSheetStatusEnum, FormElementTypeId, Grid } from '@packages/models/api';
import uuid from 'uuid';

export const WorkSheetStatuses = [
    { text: 'all', value: WorkSheetStatusEnum.All },
    { text: 'pending', value: WorkSheetStatusEnum.Pending },
    { text: 'pilot', value: WorkSheetStatusEnum.Pilot },
    { text: 'published', value: WorkSheetStatusEnum.Published },
    { text: 'archived', value: WorkSheetStatusEnum.Archived },
];

export enum RelativeDateEnum {
    ALL = 'All',
    TODAY = 'TODAY',
    YESTERDAY = 'YESTERDAY',
    THIS_WEEK = 'THIS_WEEK',
    THIS_MONTH = 'THIS_MONTH',
}
export const CreatedAndUpdateFilters = [
    { label: 'All', value: '' },
    { label: 'Today', value: RelativeDateEnum.TODAY },
    { label: 'Yesterday', value: RelativeDateEnum.YESTERDAY },
    { label: 'This Week', value: RelativeDateEnum.THIS_WEEK },
    { label: 'This Month', value: RelativeDateEnum.THIS_MONTH },
];

export const WorksheetCharacterLengthValidation = {
    QuestionLength: 1000,
    AnswerLength: 2000,
    DescriptionLength: 2000,
    TooltipsLength: 2000,
};

export const KeyOfFilterParams = {
    statuses: 'statuses',
    lastUpdatedDate: 'lastUpdatedDate',
    createdDate: 'createdDate',
};

export const isConditionalElementType = (elementTypeId: FormElementTypeId) => {
    return [FormElementTypeId.Radio, FormElementTypeId.Checkbox].includes(elementTypeId);
};

export function hasNoOptions(elementTypeId: FormElementTypeId) {
    return [
        FormElementTypeId.TextHeader,
        FormElementTypeId.TextParagraph,
        FormElementTypeId.DynamicGrid,
        FormElementTypeId.PressureTestGrid,
        FormElementTypeId.ValveClearanceGrid,
        FormElementTypeId.VehicleNoiseGrid,
    ].includes(elementTypeId);
}

export function isGridElementType(elementTypeId: FormElementTypeId) {
    return [
        FormElementTypeId.DynamicGrid,
        FormElementTypeId.PressureTestGrid,
        FormElementTypeId.ValveClearanceGrid,
        FormElementTypeId.VehicleNoiseGrid,
    ].includes(elementTypeId);
}

const ELEMENT_GRID_ID_FIELD = 'worksheetElementGridId' as const;

enum GridIdLevel {
    Column = 'column',
    SubRowColumn = 'subRowColumn',
    SubColumn = 'subColumn',
}

function getElementGridIdLevel(row: Grid): GridIdLevel | undefined {
    if (row.columns?.some((column) => ELEMENT_GRID_ID_FIELD in column)) {
        return GridIdLevel.Column;
    }

    if (row.subRows?.some((subRow) => subRow.columns?.some((column) => ELEMENT_GRID_ID_FIELD in column))) {
        return GridIdLevel.SubRowColumn;
    }

    if (row.columns?.some((column) => column.subColumns?.some((subColumn) => ELEMENT_GRID_ID_FIELD in subColumn))) {
        return GridIdLevel.SubColumn;
    }

    return undefined;
}

export function assignElementGridIds(grid: Grid[] = []) {
    if (!grid?.length) {
        return;
    }

    const firstRow = grid.find((row) => row.columns?.length || row.subRows?.length);

    if (!firstRow) {
        return;
    }

    const level = getElementGridIdLevel(firstRow);

    switch (level) {
        case GridIdLevel.Column:
            grid.forEach((row) => {
                row.columns.forEach((column) => {
                    column[ELEMENT_GRID_ID_FIELD] = uuid();
                });
            });
            return;

        case GridIdLevel.SubRowColumn:
            grid.forEach((row) => {
                row.subRows?.forEach((subRow) => {
                    subRow.columns.forEach((column) => {
                        column[ELEMENT_GRID_ID_FIELD] = uuid();
                    });
                });
            });
            return;

        case GridIdLevel.SubColumn:
            grid.forEach((row) => {
                row.columns.forEach((column) => {
                    column.subColumns?.forEach((subColumn) => {
                        subColumn[ELEMENT_GRID_ID_FIELD] = uuid();
                    });
                });
            });
            return;
    }
}
